export default {
  state: {
    allCategoriesList: [
      {
        id: "1",
        tag: "bedroom",
        src: require("@/assets/images/projects_img1.png"),
        alt: "bedroom one",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "2",
        tag: "bedroom",
        src: require("@/assets/images/projects_img2.png"),
        alt: "bedroom two",
        firstparagraph: "Classic Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "3",
        tag: "bedroom",
        src: require("@/assets/images/projects_img3.png"),
        alt: "bedroom three",
        firstparagraph: "Minimal Bedroom Table",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "4",
        tag: "bedroom",
        src: require("@/assets/images/projects_img4.png"),
        alt: "bedroom four",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "5",
        tag: "bedroom",
        src: require("@/assets/images/projects_img5.png"),
        alt: "bedroom five",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "6",
        tag: "bedroom",
        src: require("@/assets/images/projects_img6.png"),
        alt: "bedroom six",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "7",
        tag: "bedroom",
        src: require("@/assets/images/projects_img7.png"),
        alt: "bedroom seven",
        firstparagraph: "System Bedroom Table",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "8",
        tag: "bedroom",
        src: require("@/assets/images/projects_img8.png"),
        alt: "bedroom eight",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "9",
        tag: "bedroom",
        src: require("@/assets/images/projects_img1.png"),
        alt: "bedroom nine",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "10",
        tag: "bedroom",
        src: require("@/assets/images/projects_img2.png"),
        alt: "bedroom ten",
        firstparagraph: "Classic Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "11",
        tag: "bedroom",
        src: require("@/assets/images/projects_img1.png"),
        alt: "bedroom eleven",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "12",
        tag: "bedroom",
        src: require("@/assets/images/projects_img2.png"),
        alt: "bedroom twelve",
        firstparagraph: "Classic Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "13",
        tag: "bedroom",
        src: require("@/assets/images/projects_img2.png"),
        alt: "bedroom thirteen",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "14",
        tag: "bedroom",
        src: require("@/assets/images/projects_img1.png"),
        alt: "bedroom fourteen",
        firstparagraph: "Classic Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "15",
        tag: "bedroom",
        src: require("@/assets/images/projects_img2.png"),
        alt: "bedroom fifteen",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "16",
        tag: "bedroom",
        src: require("@/assets/images/projects_img1.png"),
        alt: "bedroom sixteen",
        firstparagraph: "Classic Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "17",
        tag: "bedroom",
        src: require("@/assets/images/projects_img3.png"),
        alt: "bedroom seventeen",
        firstparagraph: "Minimal Bedroom Table",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "18",
        tag: "bedroom",
        src: require("@/assets/images/projects_img4.png"),
        alt: "bedroom eighteen",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "19",
        tag: "bedroom",
        src: require("@/assets/images/projects_img3.png"),
        alt: "bedroom nineteen",
        firstparagraph: "Minimal Bedroom Table",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "20",
        tag: "bedroom",
        src: require("@/assets/images/projects_img4.png"),
        alt: "bedroom twenty",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "21",
        tag: "bedroom",
        src: require("@/assets/images/projects_img4.png"),
        alt: "bedroom twenty-one",
        firstparagraph: "Minimal Bedroom Table",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "22",
        tag: "bedroom",
        src: require("@/assets/images/projects_img3.png"),
        alt: "bedroom twenty-two",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "23",
        tag: "bedroom",
        src: require("@/assets/images/projects_img4.png"),
        alt: "bedroom twehty-three",
        firstparagraph: "Minimal Bedroom Table",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "24",
        tag: "bedroom",
        src: require("@/assets/images/projects_img3.png"),
        alt: "bedroom twenty-four",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "25",
        tag: "bedroom",
        src: require("@/assets/images/projects_img6.png"),
        alt: "bedroom twenty-five",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "26",
        tag: "bedroom",
        src: require("@/assets/images/projects_img5.png"),
        alt: "bedroom twenty-six",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "27",
        tag: "bedroom",
        src: require("@/assets/images/projects_img6.png"),
        alt: "bedroom twenty-seven",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "28",
        tag: "bedroom",
        src: require("@/assets/images/projects_img5.png"),
        alt: "bedroom twenty-eight",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "29",
        tag: "bedroom",
        src: require("@/assets/images/projects_img5.png"),
        alt: "bedroom twenty-nine",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "30",
        tag: "bedroom",
        src: require("@/assets/images/projects_img6.png"),
        alt: "bedroom thirty",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "31",
        tag: "bedroom",
        src: require("@/assets/images/projects_img5.png"),
        alt: "bedroom thirty-one",
        firstparagraph: "Minimal Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "32",
        tag: "bedroom",
        src: require("@/assets/images/projects_img6.png"),
        alt: "bedroom thirty-two",
        firstparagraph: "Modern Bedroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "33",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom1.png"),
        alt: "bathroom one",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "34",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom2.png"),
        alt: "bathroom two",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "35",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom3.png"),
        alt: "bathroom three",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "36",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom4.png"),
        alt: "bathroom four",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "37",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom5.png"),
        alt: "bathroom five",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "38",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom6.png"),
        alt: "bathroom six",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "39",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom7.png"),
        alt: "bathroom seven",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "40",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom8.png"),
        alt: "bathroom eight",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "41",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom1.png"),
        alt: "bathroom nine",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "42",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom2.png"),
        alt: "bathroom ten",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "43",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom1.png"),
        alt: "bathroom eleven",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "44",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom2.png"),
        alt: "bathroom twelve",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "45",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom2.png"),
        alt: "bathroom thirteen",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "46",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom1.png"),
        alt: "bathroom fourteen",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "47",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom2.png"),
        alt: "bathroom fifteen",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "48",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom1.png"),
        alt: "bathroom sixteen",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "49",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom3.png"),
        alt: "bathroom seventeen",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "50",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom4.png"),
        alt: "bathroom eighteen",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "51",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom3.png"),
        alt: "bathroom nineteen",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "52",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom4.png"),
        alt: "bathroom twenty",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "53",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom4.png"),
        alt: "bathroom twenty-one",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "54",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom3.png"),
        alt: "bathroom twenty-two",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "55",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom4.png"),
        alt: "bathroom twenty-three",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "56",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom3.png"),
        alt: "bathroom twenty-four",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "57",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom6.png"),
        alt: "bathroom twenty-five",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "58",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom5.png"),
        alt: "bathroom twenty-six",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "59",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom6.png"),
        alt: "bathroom twenty-seven",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "60",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom5.png"),
        alt: "bathroom twenty-eight",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "61",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom5.png"),
        alt: "bathroom twenty-nine",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "62",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom6.png"),
        alt: "bathroom thirty",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "63",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom5.png"),
        alt: "bathroom thirty-one",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "64",
        tag: "bathroom",
        src: require("@/assets/images/projects_bathroom6.png"),
        alt: "bathroom thirty-two",
        firstparagraph: "Modern Bathroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "65",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen1.png"),
        alt: "kitchen one",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "66",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen2.png"),
        alt: "kitchen two",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "67",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen3.png"),
        alt: "kitchen three",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "68",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen4.png"),
        alt: "kitchen four",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "69",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen5.png"),
        alt: "kitchen five",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "70",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen6.png"),
        alt: "kitchen six",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "71",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen7.png"),
        alt: "kitchen seven",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "72",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen8.png"),
        alt: "kitchen eight",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "73",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen1.png"),
        alt: "kitchen nine",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "74",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen2.png"),
        alt: "kitchen ten",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "75",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen1.png"),
        alt: "kitchen eleven",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "76",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen2.png"),
        alt: "kitchen twelve",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "77",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen2.png"),
        alt: "kitchen thirteen",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "78",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen1.png"),
        alt: "kitchen fourteen",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "79",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen2.png"),
        alt: "kitchen fifteen",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "80",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen1.png"),
        alt: "kitchen sixteen",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "81",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen3.png"),
        alt: "kitchen seventeen",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "82",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen4.png"),
        alt: "kitchen eighteen",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "83",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen3.png"),
        alt: "kitchen nineteen",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "84",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen4.png"),
        alt: "kitchen twenty",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "85",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen4.png"),
        alt: "kitchen twenty-one",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "86",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen3.png"),
        alt: "kitchen twenty-two",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "87",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen4.png"),
        alt: "kitchen twenty-three",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "88",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen3.png"),
        alt: "kitchen twenty-four",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "89",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen6.png"),
        alt: "kitchen twenty-five",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "90",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen5.png"),
        alt: "kitchen twenty-six",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "91",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen6.png"),
        alt: "kitchen twenty-seven",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "92",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen5.png"),
        alt: "kitchen twenty-eight",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "93",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen5.png"),
        alt: "kitchen twenty-nine",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "94",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen6.png"),
        alt: "kitchen thirty",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "95",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen5.png"),
        alt: "kitchen thirty-one",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "96",
        tag: "kitchen",
        src: require("@/assets/images/projects_kitchen6.png"),
        alt: "kitchen thirty-two",
        firstparagraph: "Modern Kitchen",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "97",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom1.png"),
        alt: "livingroom one",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "98",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom2.png"),
        alt: "livingroom two",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "99",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom3.png"),
        alt: "livingroom three",
        firstparagraph: "Modern Livingroom 3",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "100",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom4.png"),
        alt: "livingroom four",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "101",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom5.png"),
        alt: "livingroom five",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "102",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom6.png"),
        alt: "livingroom six",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "103",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom7.png"),
        alt: "livingroom seven",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "104",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom8.png"),
        alt: "livingroom eight",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "105",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom1.png"),
        alt: "livingroom nine",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "106",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom2.png"),
        alt: "livingroom ten",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "107",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom1.png"),
        alt: "livingroom eleven",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "108",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom2.png"),
        alt: "livingroom twelve",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "109",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom2.png"),
        alt: "livingroom thirteen",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "110",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom1.png"),
        alt: "livingroom fourteen",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "111",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom2.png"),
        alt: "livingroom fifteen",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "112",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom1.png"),
        alt: "livingroom sixteen",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "113",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom3.png"),
        alt: "livingroom seventeen",
        firstparagraph: "Modern Livingroom 3",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "114",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom4.png"),
        alt: "livingroom eighteen",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "115",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom3.png"),
        alt: "livingroom nineteen",
        firstparagraph: "Modern Livingroom 3",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "116",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom4.png"),
        alt: "livingroom twenty",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "117",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom4.png"),
        alt: "livingroom twenty-one",
        firstparagraph: "Modern Livingroom 3",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "118",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom3.png"),
        alt: "livingroom twenty-two",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "119",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom4.png"),
        alt: "livingroom twenty-three",
        firstparagraph: "Modern Livingroom 3",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "120",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom3.png"),
        alt: "livingroom twenty-four",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },

      {
        id: "121",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom6.png"),
        alt: "livingroom twenty-five",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "122",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom5.png"),
        alt: "livingroom twenty-six",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "123",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom6.png"),
        alt: "livingroom twenty-seven",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "124",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom5.png"),
        alt: "livingroom twenty-eight",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "125",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom5.png"),
        alt: "livingroom twenty-nine",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "126",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom6.png"),
        alt: "livingroom thirty",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "127",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom5.png"),
        alt: "livingroom thirty-one",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
      {
        id: "128",
        tag: "livingroom",
        src: require("@/assets/images/projects_livingroom6.png"),
        alt: "livingroom thirty-two",
        firstparagraph: "Modern Livingroom",
        secondparagraph: "Decor / Artchitecture",
      },
    ],
  },
  getters: {
    getAllCategoriesList(state) {
      return state.allCategoriesList;
    },
  },
};
